import { Progress } from 'antd';
import styled from 'styled-components';

export const AcceptProgress = styled(Progress)`
  .ant-progress-text {
    font-size: 48px;
  }
`;

export const AcceptProgressOuter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
